import { api } from "./rtkApi";

export const eventsApi = api.injectEndpoints({
	endpoints: (build) => ({
		getEvents: build.query({
			query: ({ activites, authToken, offset, limit }) => {
				return {
					method: "GET",
					url: `/evenement/list?activites=${activites}&idinexplore=0&offset=${offset}&limit=${limit}`,
				};
			},
		}),
		getEvent: build.query({
			query: ({ slug }) => {
				return {
					method: "GET",
					url: `/evenement/get/${slug}`,
				};
			},
		}),
		getEventDates: build.query({
			query: ({ id }) => {
				return {
					method: "GET",
					url: `/evenement/dates/${id}`,
				};
			},
		}),
		getEventDate: build.query({
			query: ({ idDate }) => {
				return {
					method: "GET",
					url: `/evenement/get-date/${idDate}`,
				};
			},
		}),
		getVote: build.query({
			query: ({ id, authToken }) => {
				return {
					method: "GET",
					url: `/evenement/get-vote/${id}`,
					headers: {
						authorization: "Bearer " + authToken,
						"Content-Type": "application/json",
					},
				};
			},
		}),
		updateVote: build.mutation({
			query: ({ id, vote, authToken }) => {
				return {
					method: "PATCH",
					url: `/evenement/update-vote/${id}`,
					headers: {
						authorization: "Bearer " + authToken,
						"Content-Type": "application/json",
					},
					body: { vote},
				};
			},
		}),
	}),
	overrideExisting: true,
});

export const {
	useGetEventsQuery,
	useLazyGetEventsQuery,
	useGetEventQuery,
	useLazyGetEventQuery,
	useGetEventDatesQuery,
	useLazyGetEventDatesQuery,
	useGetEventDateQuery,
	useLazyGetEventDateQuery,

	useUpdateVoteMutation,
	useLazyGetVoteQuery
} = eventsApi;
